<template>
  <div class="flex items-center justify-end space-x-1 mt-4">
    <!-- Previous Button -->
    <button
      @click="changePage(currentPage - 1)"
      :disabled="currentPage === 1"
      class="px-3 py-1 text-sm font-normal border rounded disabled:opacity-50"
    >
      &laquo;
    </button>

    <!-- First Page -->
    <button
      @click="changePage(1)"
      :class="['px-3 py-1 text-sm font-normal border rounded', { 'bg-blue-500 text-white': currentPage === 1 }]"
    >
      1
    </button>

    <!-- Dots Before -->
    <span v-if="showLeftDots" class="px-2">...</span>

    <!-- Dynamic Pages -->
    <button
      v-for="page in visiblePages"
      :key="page"
      @click="changePage(page)"
      :class="['px-3 py-1 text-sm font-normal border rounded', { 'bg-blue-500 text-white': page === currentPage }]"
    >
      {{ page }}
    </button>

    <!-- Dots After -->
    <span v-if="showRightDots" class="px-2">...</span>

    <!-- Last Page -->
    <button
      v-if="totalPages > 1"
      @click="changePage(totalPages)"
      :class="['px-3 py-1 text-sm font-normal border rounded', { 'bg-blue-500 text-white': currentPage === totalPages }]"
    >
      {{ totalPages }}
    </button>

    <!-- Next Button -->
    <button
      @click="changePage(currentPage + 1)"
      :disabled="currentPage === totalPages"
      class="px-3 py-1 text-sm font-normal border rounded disabled:opacity-50"
    >
      &raquo;
    </button>
  </div>
</template>

<script>
export default {
  props: {
    totalItems: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      let start = Math.max(2, this.currentPage - 1);
      let end = Math.min(this.totalPages - 1, this.currentPage + 1);

      if (this.currentPage === 1) {
        end = Math.min(3, this.totalPages - 1);
      }
      if (this.currentPage === this.totalPages) {
        start = Math.max(2, this.totalPages - 2);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    showLeftDots() {
      return this.totalPages > 5 && this.currentPage > 3;
    },
    showRightDots() {
      return this.totalPages > 5 && this.currentPage < this.totalPages - 2;
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.$emit("update:currentPage", page);
      }
    }
  }
};
</script>
